import React, { PropTypes } from "react";
import update from "react-addons-update";
import { connect } from "react-redux";
import { FieldArray } from "redux-form";
import { DropTarget } from "react-dnd";
import classNames from "classnames";

import { RenderLineItems } from "./";

class BlocClientsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: props.list,
    };

    this.moveClient = this.moveClient.bind(this);
    this.removeClient = this.removeClient.bind(this);
  }

  moveClient(dragIndex, hoverIndex) {
    const { clients } = this.state;
    const dragClient = clients[dragIndex];

    this.setState(
      update(this.state, {
        clients: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragClient],
          ],
        },
      })
    );
  }

  pushClient(client) {
    const { blocId } = this.props;

    this.setState(
      update(this.state, {
        clients: {
          $push: [{ ...client, blocId }],
        },
      })
    );
  }

  removeClient(index) {
    this.setState(
      update(this.state, {
        clients: {
          $splice: [[index, 1]],
        },
      })
    );
  }

  render() {
    const { clients } = this.state;
    const {
      id,
      canDrop,
      disabled,
      formValues,
      blocId,
      isOver,
      connectDropTarget,
    } = this.props;
    const containerClasses = classNames({
      "guarantee-container": true,
      active: canDrop && isOver,
    });

    return connectDropTarget(
      <div className={containerClasses}>
        <FieldArray
          formValues={formValues}
          name={`${id}Clients`}
          component={RenderLineItems}
          id={id}
          props={{
            clients,
            disabled,
            blocId,
            moveClient: this.moveClient,
            removeClient: this.removeClient,
          }}
        />
      </div>
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    const { blocId, id } = props;
    const sourceObj = monitor.getItem();

    let alreadyAssigned = false;

    if (blocId !== null && sourceObj.client.blocId !== blocId) {
      if (props.formValues.assignedClients) {
        props.formValues.assignedClients.map((client) => {
          if (client.clientId === sourceObj.client.clientId) {
            alreadyAssigned = true;
          }
        });
      }
    }

    if (id != "unassigned" && !alreadyAssigned) {
      if (id !== sourceObj.listId) {
        component.pushClient(sourceObj.client);
      }
    }

    return {
      listId: id != "unassigned" && !alreadyAssigned ? id : sourceObj.listId,
    };
  },
};

BlocClientsContainer.propTypes = {
  canDrop: PropTypes.bool,
  connectDropTarget: PropTypes.func,
  disabled: PropTypes.bool,
  formValues: PropTypes.object,
  blocId: PropTypes.string,
  id: PropTypes.string,
  isOver: PropTypes.bool,
  list: PropTypes.array,
};

export default connect(null, null, null, { withRef: true })(
  DropTarget("BLOC_CLIENT", cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }))(BlocClientsContainer)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/BlocClientsContainer.js